<!-- Modals -->
<app-deprecated-modal-form
    #editModal
    headerText="benefits.benefitPlanShow.editModal.headerText"
    [form]="benefitPlanForm"
    (save)="onSaveBenefitPlan()"
    (cancel)="onCancelBenefitPlan()"
>
    <app-form-benefit-plan #benefitPlanForm [benefitPlan]="benefitPlan"></app-form-benefit-plan>
</app-deprecated-modal-form>

<!-- Dialogs -->
<app-deprecated-confirmation-dialog
    #deleteConfirmationDialog
    [description]="'benefits.benefitPlanShow.deleteConfirmationDialog.description'"
    [label]="'benefits.benefitPlanShow.deleteConfirmationDialog.label'"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #deleteBenefitConfirmationDialog
    [description]="'benefits.benefitPlanShow.deleteBenefitConfirmationDialog.description'"
    [label]="'benefits.benefitPlanShow.deleteBenefitConfirmationDialog.label'"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading" *ngIf="benefitPlan">
    <app-header
        [title]="benefitPlan.name"
        [menuService]="benefitShowMenuService"
        [back]="true"
        backRoute="/benefits/plans"
        [contextMenu]="canModifyBenefits"
        contextMenuType="material"
    >
        <button *ngIf="canModifyBenefits" mat-menu-item (click)="onDeleteBenefitPlan()">
            {{ 'benefits.benefitPlanShow.delete' | translate }}
        </button>
        <div *ngIf="canModifyBenefits" class="buttons">
            <ui-button [routerLink]="['benefits']" type="primary">
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'benefits.benefitPlanShow.createBenefit' | translate }}
            </ui-button>
        </div>
    </app-header>

    <div class="ui stackable grid raised segment no-padding">
        <ui-button *ngIf="canModifyBenefits" type="link" class="edit" (click)="editModal.show()">
            {{ 'benefits.benefitPlanShow.edit' | translate }}
        </ui-button>
        <div class="three wide column flex center stacked">
            <img
                class="ui left floated image logo"
                [attr.src]="'/assets/img/brands/' + benefitPlan.benefitProvider?.logoUrl"
            />
            <a [attr.href]="benefitPlan.benefitProvider?.adminPortalUrl" target="_blank">
                {{ 'benefits.benefitPlanShow.carrierPortal' | translate }}
            </a>
        </div>
        <div class="three wide column flex center">
            <div>
                <span class="heading">{{ 'benefits.benefitPlanShow.policyNumber' | translate }}</span>
                <span class="value">{{ benefitPlan.policyNumber || 'None' }}</span>
            </div>
        </div>
        <div class="two wide column flex center">
            <div>
                <span class="heading">{{ 'benefits.benefitPlanShow.probationPeriod' | translate }}</span>
                <span class="value capitalize">{{ benefitPlan.probationPeriodDescription | appTranslate }}</span>
            </div>
        </div>
        <div class="three wide column flex center">
            <div>
                <span class="heading">{{ 'benefits.benefitPlanShow.effectiveDate' | translate }}</span>
                <span class="value">{{ benefitPlan.startAt | appDate: 'longDate' }}</span>
            </div>
        </div>
        <div *ngIf="benefitPlan.fileId" class="two wide column flex center">
            <div>
                <span class="heading">{{ 'benefits.benefitPlanShow.benefitsBooklet' | translate }}</span>
                <span class="value">
                    <a (click)="onDownloadPlan(benefitPlan)">{{ 'benefits.benefitPlanShow.download' | translate }}</a>
                </span>
            </div>
        </div>
        <div *ngIf="benefitPlan.planUrl" class="two wide column flex center">
            <div>
                <span class="heading">{{ 'benefits.benefitPlanShow.planUrl' | translate }}</span>
                <span class="value">
                    <a target="_blank" [attr.href]="benefitPlan.planUrl">{{
                        'benefits.benefitPlanShow.viewPortal' | translate
                    }}</a>
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="!benefitPlan.benefits?.length" class="ui segment empty">
        <img class="benefits-img" src="/assets/illustrations/benefits.png" />
        <h2 class="ui centered header">{{ 'benefits.benefitPlanShow.noBenefits' | translate }}</h2>
        <a [routerLink]="['benefits']" class="ui primary collapsing button">{{
            'benefits.benefitPlanShow.addBenefit' | translate
        }}</a>
    </div>

    <!-- Benefits -->
    <div *ngFor="let benefit of benefitPlan.benefits" class="ui segment benefit">
        <app-segment-header
            [title]="benefit.benefitCategory?.name"
            [contextMenu]="canModifyBenefits"
            contextMenuType="material"
        >
            <button *ngIf="canModifyBenefits" mat-menu-item [routerLink]="['benefits', benefit.id]">
                {{ 'benefits.benefitPlanShow.edit' | translate }}
            </button>
            <button *ngIf="canModifyBenefits" mat-menu-item (click)="onDeleteBenefit(benefit)">
                {{ 'benefits.benefitPlanShow.delete' | translate }}
            </button>
        </app-segment-header>
        <!-- Provider and File -->
        <div class="flex justify space-between">
            <div>
                <div class="benefit-description">{{ benefit.description }}</div>
                <!-- Benefit Detail Without Type -->
                <div *ngFor="let detail of benefit.benefitDetails | groupBy: 'benefitTypeId'" class="benefit">
                    <ng-container *ngIf="!detail.value[0]?.benefitType">
                        <!-- Coverage Descriptions -->
                        <div *ngFor="let coverage of detail.value" class="benefit-detail-description">
                            <div class="benefit-description">{{ coverage.description }}</div>
                        </div>
                        <!-- Coverages -->
                        <div *ngFor="let coverage of detail.value" class="benefit-details">
                            <div class="ui static form">
                                <div *ngIf="coverage.coverage" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.coverage' | translate }}</label>
                                    {{ coverage.coverage }}%
                                </div>
                                <div *ngIf="coverage.reimbursement" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.reimbursement' | translate }}</label>
                                    {{ coverage.reimbursement | currency }}
                                </div>
                                <div *ngIf="coverage.deductible" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.deductible' | translate }}</label>
                                    {{ coverage.deductible | currency }}
                                </div>
                                <div *ngIf="coverage.max" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.maximum' | translate }}</label>
                                    {{ coverage.max | currency }}
                                </div>
                                <div *ngIf="coverage.nem" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.nonEvidenceMaximum' | translate }}</label>
                                    {{ coverage.nem | currency }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <!-- Benefit Details With Type -->
                <div *ngFor="let detail of benefit.benefitDetails | groupBy: 'benefitTypeId'" class="benefitWithType">
                    <ng-container *ngIf="detail.value[0]?.benefitType">
                        <h4 class="ui header">{{ detail.value[0].benefitType?.name }}</h4>
                        <!-- Coverage Descriptions -->
                        <div *ngFor="let coverage of detail.value" class="benefit-detail-description">
                            <div class="benefit-description">{{ coverage.description }}</div>
                        </div>
                        <!-- Coverages -->
                        <div *ngFor="let coverage of detail.value" class="benefit-details">
                            <div class="ui static form">
                                <div *ngIf="coverage.coverage" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.coverage' | translate }}</label>
                                    {{ coverage.coverage }}%
                                </div>
                                <div *ngIf="coverage.reimbursement" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.reimbursement' | translate }}</label>
                                    {{ coverage.reimbursement | currency }}
                                </div>
                                <div *ngIf="coverage.deductible" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.deductible' | translate }}</label>
                                    {{ coverage.deductible | currency }}
                                </div>
                                <div *ngIf="coverage.max" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.maximum' | translate }}</label>
                                    {{ coverage.max | currency }}
                                </div>
                                <div *ngIf="coverage.nem" class="inline field">
                                    <label>{{ 'benefits.benefitPlanShow.nonEvidenceMaximum' | translate }}</label>
                                    {{ coverage.nem | currency }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div>
                <img
                    *ngIf="benefit.benefitProvider"
                    class="ui image provider-logo"
                    [attr.src]="'/assets/img/brands/' + benefit.benefitProvider?.logoUrl"
                />
                <span *ngIf="benefit.fileId && !benefit.benefitProvider"
                    ><i class="fa fal fa-3x fa-file"></i><br /><br
                /></span>
                <ui-button type="link" *ngIf="benefit.fileId" (click)="onDownloadBenefit(benefitPlan, benefit)">{{
                    'benefits.benefitPlanShow.downloadBooklet' | translate
                }}</ui-button>
            </div>
        </div>
    </div>
</div>
